import { render, staticRenderFns } from "./ProjectDetailPage.vue?vue&type=template&id=f7b15b8a&scoped=true&lang=pug&"
import script from "./ProjectDetailPage.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b15b8a",
  null
  
)

export default component.exports